import { useState } from 'react';
import apiClient from '../utils/api';

interface DailyActivityEntry {
  activityLevel: number;
}

export const useDailyActivity = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createDailyActivity = async (entry: DailyActivityEntry): Promise<boolean> => {
    setLoading(true);
    setError(null);

    try {
      await apiClient.post('/daily-activity', entry);
      return true;
    } catch (err: any) {
      const errorMessage = err.response?.data?.error || 'Failed to save daily activity. Please try again.';
      setError(errorMessage);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    createDailyActivity,
    loading,
    error,
  };
};
